import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import Cache from 'i18next-localstorage-cache';
import LanguageDetector from 'i18next-browser-languagedetector';

const options = {
    backend: {
        loadPath: jsRoutes.controllers.Assets.at('').url + '/locales/__lng__/__ns__.json'
    },
    cache: {
        enabled: true,
        expirationTime: 60 * 60 * 1000, // 1 hours
        prefix: THEME_GRANITE ? 'granite_i18next_res_' : 'i18next_res_'
    },
    debug: false, // False in production
    defaultNS: 'translation',
    fallbackLng: 'en',
    lng: globalCurrentLang,
    ns: ['translation'],
    interpolation: {
        prefix: "__",
        suffix: "__",
    }
};

let instance = null;

window.i18nInit = function (callback) {
    instance = i18n
        .use(XHR)
        .use(Cache)
        .use(LanguageDetector)
        .init(options, callback);
};

const i18nProxy = {
    t: function(key, params) {
        return instance.t(key, params)
    }
};

window.i18n = i18nProxy;

export { i18nProxy as i18n };



// WEBPACK FOOTER //
// ./app/assets/granite/js/i18n.js